(function () {
  'use strict';

  document.querySelectorAll('.product-section, .quick-add').forEach(initProductSection);

  window.EveryRise = window.EveryRise || {};
  window.EveryRise.initProductForms = function (root) {
    root.querySelectorAll('.product-section, .quick-add').forEach(initProductSection);
  };

  function initProductSection(section) {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';

    const productId = section.dataset.productId || section.querySelector('[data-product-id]')?.dataset.productId;
    const productData = window.productJson && productId ? window.productJson[productId] : getEmbeddedProductJson(section);
    if (!productData) return;

    const form = section.querySelector('#ProductForm, #QuickAddForm');
    if (!form) return;
    const idInput = form.querySelector('[data-product-form-id]');
    const optionButtons = section.querySelectorAll('[data-option-name]');
    const selectedOptions = {};

    // seed selectedOptions from currently-selected buttons
    section.querySelectorAll('.product-form__option').forEach((optWrap) => {
      const selected = optWrap.querySelector('.is-selected');
      if (selected) selectedOptions[selected.dataset.optionName] = selected.dataset.optionValue;
    });

    function findVariant() {
      return productData.variants.find((v) =>
        v.options.every((val, idx) => {
          const optionName = productData.options[idx];
          return selectedOptions[optionName] === undefined || selectedOptions[optionName] === val;
        })
      );
    }

    function updateUI(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;

      const priceWrap = section.querySelector('[data-product-price]');
      if (priceWrap) {
        priceWrap.querySelectorAll('.price__regular, .price__sale-value').forEach((el) => (el.textContent = formatMoney(variant.price)));
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWrap.classList.add('price--on-sale');
          const compare = priceWrap.querySelector('.price__compare-value');
          if (compare) compare.textContent = formatMoney(variant.compare_at_price);
        }
      }

      const addBtn = section.querySelector('[data-add-to-cart]');
      const stickyBtn = section.querySelector('[data-sticky-add-to-cart]');
      const addText = section.querySelector('[data-add-to-cart-text]');
      [addBtn, stickyBtn].forEach((btn) => {
        if (!btn) return;
        btn.toggleAttribute('disabled', !variant.available);
      });
      if (addText) addText.textContent = variant.available ? (window.themeStrings?.addToCart || 'Add to Cart') : (window.themeStrings?.soldOut || 'Sold Out');

      const stickyPrice = section.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      if (variant.featured_media) {
        const mediaId = variant.featured_media.id;
        const slide = section.querySelector(`[data-media-id="${mediaId}"]`);
        if (slide) showSlide(section, mediaId);
      }
    }

    optionButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const wrap = btn.closest('.product-form__option');
        wrap.querySelectorAll('[data-option-name]').forEach((b) => {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        const valueLabel = wrap.querySelector('[data-option-selected-value]');
        if (valueLabel) valueLabel.textContent = btn.dataset.optionValue;
        selectedOptions[btn.dataset.optionName] = btn.dataset.optionValue;
        updateUI(findVariant());
      });
    });

    // Gallery thumbnails
    section.querySelectorAll('[data-gallery-thumbs] [data-media-id]').forEach((thumb) => {
      thumb.addEventListener('click', () => showSlide(section, thumb.dataset.mediaId));
    });
  }

  function showSlide(section, mediaId) {
    const slides = section.querySelectorAll('[data-gallery-main] [data-media-id]');
    slides.forEach((slide) => {
      slide.hidden = slide.dataset.mediaId !== String(mediaId);
    });
    const thumbs = section.querySelectorAll('[data-gallery-thumbs] [data-media-id]');
    thumbs.forEach((thumb) => {
      thumb.classList.toggle('is-active', thumb.dataset.mediaId === String(mediaId));
    });
  }

  function getEmbeddedProductJson(section) {
    const script = section.querySelector('[data-product-json]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* Sticky add-to-cart visibility */
  const sticky = document.getElementById('StickyAddToCart');
  const productInfo = document.getElementById('ProductInfo');
  if (sticky && productInfo && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '-120px 0px 0px 0px' }
    );
    const addBtn = productInfo.querySelector('.product-form__add-to-cart');
    if (addBtn) observer.observe(addBtn);
  }
})();
